import { Box } from '@mui/material';

import {
  ActionIconButton,
  CustomTextField,
} from '../../../common/components';

const AccountingEntryLineRow = ({
  line,
  index,
  canRemove,
  onChange,
  onRemove,
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: '1fr',
        md: '36px minmax(0, 1fr) 130px 130px 56px',
      },
      gap: 1.25,
      alignItems: 'start',
      p: 1.25,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      minWidth: 0,
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', md: 'center' },
        minHeight: 56,
        mt: '12px',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        color: 'primary.main',
        fontWeight: 800,
        fontSize: '0.9rem',
        backgroundColor: 'background.formTables',
        px: { xs: 1.5, md: 0 },
      }}
    >
      <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
        {`Línea ${index + 1}`}
      </Box>
      <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
        {index + 1}
      </Box>
    </Box>

    <CustomTextField
      label="Cuenta contable"
      value={line.account_label}
      onChange={(event) => onChange(index, 'account_label', event.target.value)}
      sx={{ width: '100%', minWidth: 0 }}
    />
    <CustomTextField
      label="Debe"
      value={line.debit_amount}
      onChange={(event) => onChange(index, 'debit_amount', event.target.value)}
      inputProps={{ inputMode: 'decimal' }}
      sx={{ width: '100%', minWidth: 0 }}
    />
    <CustomTextField
      label="Haber"
      value={line.credit_amount}
      onChange={(event) => onChange(index, 'credit_amount', event.target.value)}
      inputProps={{ inputMode: 'decimal' }}
      sx={{ width: '100%', minWidth: 0 }}
    />
    <Box
      sx={{
        mt: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', md: 'center' },
        minHeight: 56,
      }}
    >
      <ActionIconButton
        variant="delete"
        aria-label={`Quitar línea ${index + 1}`}
        onClick={() => onRemove(index)}
        disabled={!canRemove}
        sx={{ height: 56, width: 56, minWidth: 56 }}
      />
    </Box>
  </Box>
);

export default AccountingEntryLineRow;
